import React from 'react';
import './HomePage.css'
import Features from './Features'
import Image from './ImageGrid'
import Terminal from './Terminal'
import Typewriter from './Typewriter'
import TechStack from './TechStack'
import NIDS from './NIDS'
import LogoSlider from './LogoSlider'
import Footer from './Footer'

const NIDSReport = () => {
  return (
    <>
     <NIDS/>

    <div className='section2'>
        <div className="halfdiv1">
        <img src="./img1.png" alt="Image" className='img-fluid' style={{ maxHeight: '400px'}} />
        </div>
        <div className="halfdiv">
        <h2><strong>Why NIDS is Necessary ?</strong></h2>
        <p style={{marginTop:'40px'}}>
        In today's interconnected world, network security is paramount. Cyber threats are constantly evolving, becoming more sophisticated and harder to detect. Network Intrusion Detection Systems (NIDS) provide a crucial layer of defense by monitoring network traffic in real-time, identifying potential threats, and alerting security teams to take action.
        </p>
        <p>
        NIDS helps organizations stay one step ahead of attackers by analyzing patterns, detecting anomalies, and providing valuable insights into network behavior. This proactive approach is essential in maintaining the integrity and security of modern networks.
        </p>
        </div>
    </div>
   
    <div className='section3'>
    <h1 style={{fontSize: '2.5rem',marginTop:'5rem'}}><strong>How NIDS Works</strong></h1>
          <div className='d-flex justify-content-around align-items-center p-3 flex-wrap'>

          <div className="card" style={{width: '20rem', height: '250px',margin: '2rem'}}>
          <div className="card-body">
          <i class="bi bi-dropbox" style={{ fontSize: '3rem' }}></i>
            <h2 className="card-title">Packet Capture</h2>
            <p className="card-text">Intercept network traffic</p>
          </div>
        </div>

  
        <div className="card" style={{ width: '20rem', height: '250px',margin: '2rem' }}>
        
          <div className="card-body">
          <i class="bi bi-search" style={{ fontSize: '3rem' }}></i>
            <h2 className="card-title">Analysis</h2>
            <p className="card-text">Examine packets for threats</p>
          </div>
        </div>

        <div className="card" style={{ width: '20rem', height: '250px',margin: '2rem' }}>
        
          <div className="card-body">
          <i class="bi bi-bell" style={{ fontSize: '3rem' }}></i>
            <h2 className="card-title">Alert Generation</h2>
            <p className="card-text">Notify of potential intrusions</p>
          </div>
        </div>
        </div>
    </div>
    <div className="section4">
    <h1 style={{fontSize: '2.5rem',marginTop:'5rem'}}><strong>Unveiling the Features</strong></h1>
    <div style={{marginTop:'40px'}}>
    <Features/>
    </div>
        
    </div>
    <div className="section5">
    <h1 style={{fontSize: '2.5rem',marginTop:'5rem'}}><strong>Project Visuals</strong></h1>
        <Image/>
    </div>
    <h1><strong>Adaptive Rules for Threat Detection</strong></h1>
    <div className="section6">
   <div className='halfdiv1' style={{ height: '400px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
     <Typewriter />
   </div>
   <div className='halfdiv1' style={{ overflow: 'hidden', height: '600px' }}>
     <Terminal />
   </div>
</div>

    <div className="section7">
    <h1 style={{fontSize: '2.5rem',marginTop:'5rem'}}><strong>Technology Stack</strong></h1>
    <TechStack/>
    <LogoSlider/>
    </div>
    <Footer/>
    </>
  );
};

export default NIDSReport;
